export function preloadUserChunk() {
  import('userportal/pages/User').catch(() => {});
}
